import { apiFetch, HTTPMethod } from '../fetch';
import { CompanyAccountManager } from './interfaces';

export const getCompanyAccountManagers = (companyId?: string) => {
  const url = companyId ? `/CompanyAccountManagers?companyId=${companyId}` : '/CompanyAccountManagers';
  return apiFetch<CompanyAccountManager[]>(url);
};

export const UpdateCompanyAccountManagersForCompany = (companyId: string, companyAccountManagers: CompanyAccountManager[]) =>
  apiFetch<CompanyAccountManager[]>(`/CompanyAccountManagers/${companyId}/updateforcompany`, companyAccountManagers, HTTPMethod.PUT);